import { PropsWithChildren } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WorkScheduleTabs from 'modules/work_schedules/components/Tabs'
import type Schedule from 'modules/work_schedules/store/models/Schedule'

import EmployeesTable from './EmployeesTable'

interface Props {
  loading: boolean
  workSchedule: Schedule
  canAssignEmployees: boolean
}

const WorkScheduleEmployees = ({
  loading,
  workSchedule,
  children,
  canAssignEmployees,
}: PropsWithChildren<Props>) => {
  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={null}>
      <Box padding="s16" gap="s16">
        <WorkScheduleTabs canAssignEmployees={canAssignEmployees} />
        <Box paddingX="s24">
          <EmployeesTable workSchedule={workSchedule} canAssignEmployees={canAssignEmployees} />
        </Box>
        {children}
      </Box>
    </ResponsivePage.Body>
  )
}

export default observer(WorkScheduleEmployees)
